// File: src/components/common/CardDescription.js
// -----------------------------------------------------
import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { truncateText } from '../../utils/textUtils';

/**
 * Content synopsis component with truncation
 */
const CardDescription = ({ children, maxLength = 140, lines = 3, ...props }) => (
  <Typography
    variant="body2"
    color="text.secondary"
    sx={{
      display: '-webkit-box',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: lines,
      lineHeight: 1.5,
      mb: 1,
      ...props.sx
    }}
    {...props}
  >
    {typeof children === 'string' ? truncateText(children, maxLength) : children}
  </Typography>
);

CardDescription.propTypes = {
  children: PropTypes.node,
  maxLength: PropTypes.number,
  lines: PropTypes.number,
  sx: PropTypes.object
};

export default CardDescription;